import React from 'react';
import {
    Box,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    CircularProgress,
} from '@mui/material';
import { useAtom, useAtomValue, WritableAtom } from 'jotai';
import { errorAtom } from 'atoms/error';
import { authTokenAtom } from 'atoms/authAtoms';
import { useProjects } from 'utils/hooks/useLToolTree';
import { useAutoSelectSingle } from 'utils/hooks/useAutoSelectSingle';

type Props = {
    atom: WritableAtom<string, [newProjectId: string], void>;
};

export const ProjectSelect: React.FC<Props> = ({ atom }) => {
    const authToken = useAtomValue(authTokenAtom);
    const { items: projects, loading } = useProjects(authToken);
    const [projectId, setProjectId] = useAtom(atom);
    const [error] = useAtom(errorAtom);
    // 選択肢が1件のみの段は自動選択し、一意に定まる限り下位へ連鎖させる
    useAutoSelectSingle(projects, loading, projectId, setProjectId);

    return (
        <Box sx={{ flex: '1 1 calc(50% - 16px)' }}>
            <FormControl fullWidth disabled={loading} error={Boolean(error)}>
                <InputLabel id="project-select-label">Project</InputLabel>
                <Select
                    labelId="project-select-label"
                    value={projectId}
                    label="Project"
                    onChange={(e) => setProjectId(e.target.value as string)}
                >
                    <MenuItem value="">
                        <em>None</em>
                    </MenuItem>
                    {projects.map((project) => (
                        <MenuItem key={project} value={project}>
                            {project}
                        </MenuItem>
                    ))}
                </Select>
                {loading && (
                    <CircularProgress
                        size={24}
                        sx={{ position: 'absolute', top: '50%', right: 16, mt: '-12px' }}
                    />
                )}
            </FormControl>
        </Box>
    );
};
